import styled from '@emotion/styled';

export const MainBlock = styled.div`
  position: relative;
  transition: color 0.2s ease;
  cursor: pointer;
  user-select: none;
`;
